import { Component, OnInit, Input, forwardRef, EventEmitter, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DatePickerComponent),
      multi: true,
    }
  ]
})
export class DatePickerComponent implements OnInit, ControlValueAccessor {
  @Input() allowNow: boolean;
  @Input() disabled: boolean;
  @Output() dateChanged: EventEmitter<number> = new EventEmitter();
  stateNow: boolean;
  selectedDate: number;
  change = (_: any) => { };

  constructor() {
    this.allowNow = false;
  }

  ngOnInit() {
    if (this.allowNow) {
      setTimeout(() => this.onSetNow(true));
    }
  }

  writeValue(obj: any): void {
    this.selectedDate = obj;
  }

  registerOnChange(fn: any): void {
    this.change = fn;
  }

  registerOnTouched(fn: any): void { }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onSetNow(state: boolean) {
    this.stateNow = state;
    this.selectedDate = null;
    setTimeout(() => {
      this.change(state ? new Date().getTime() : null);
      this.dateChanged.emit(state ? new Date().getTime() : null);
    });
  }

  onSetDate(date: Date) {
    const newDate = date ? date.getTime() : null;
    if (!this.allowNow || (!this.stateNow && this.selectedDate !== newDate)) {
      setTimeout(() => {
        this.change(newDate);
        this.dateChanged.emit(newDate);
      });
    }
  }

  isDisabled() {
    return this.disabled || (this.allowNow && this.stateNow);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/date-picker/date-picker.component.ts